export function selectPhotoIsArchived(state) {
    return state.photoIsArchived;
}

export function selectPhotoIsPreArchived(state) {
    return state.photoIsPreArchived;
}

export function selectPlanIsArchived(state) {
    return state.planIsArchived;
}

export function selectPlanIsPreArchived(state) {
    return state.planIsPreArchived;
}

export function selectArchivedStatus(state) {
    return state.archivedStatus;
}

export function selectArchivedInfo(state) {
    return {
        photoIsArchived: selectPhotoIsArchived(state.orders),
        photoIsPreArchived: selectPhotoIsPreArchived(state.orders),
        planIsArchived: selectPlanIsArchived(state.orders),
        planIsPreArchived: selectPlanIsPreArchived(state.orders),
        archivedStatus: selectArchivedStatus(state.orders)
    };
}
